import React, { useState, useEffect } from 'react'
import { getServicosAdmin, createServico, updateServico, uploadMidiaServico, getConfiguracoes, salvarOrdemCategorias } from '../../lib/supabase'
import { ordenarCategorias } from '../../lib/categorias'
import { useTenant } from '../../contexts/TenantContext'
import { useAuth } from '../../contexts/AuthContext'
import { useToast } from '../../contexts/ToastContext'
import Loading from '../../components/Loading'

// Acima deste tamanho avisamos (não bloqueamos) o gestor: vídeos pesados
// prejudicam a fluidez no telemóvel dos clientes no booking.
const AVISO_TAMANHO_MB = 10

const inputStyle = {
  width: '100%', padding: '9px 12px',
  border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio)',
  fontSize: '14px', fontFamily: 'var(--font-ui)',
  background: 'var(--cor-branco)', color: 'var(--cor-texto)',
}

// Taxas de IVA (código Vendus → rótulo). NOR é o default.
const IVA_TAXAS = [
  { codigo: 'NOR', label: 'Normal (23%)' },
  { codigo: 'INT', label: 'Intermédia (13%)' },
  { codigo: 'RED', label: 'Reduzida (6%)' },
  { codigo: 'ISE', label: 'Isento' },
  { codigo: 'NS', label: 'Não sujeito' },
]

const VAZIO = { nome: '', descricao: '', categoria: '', preco: '0', sinal_valor: '', iva_taxa: 'NOR', duracao_min: '60', duracao_real_min: '60', ordem: '0', ativo: true, visivel_publico: true, midia_url: '', midia_tipo: '', descricao_detalhada: '' }

function FormServico({ form, setForm, categorias, novaCategoria, setNovaCategoria, onSave, onCancel, guardando, titulo, podeMidia, onUpload, aEnviarMidia }) {
  return (
    <div style={{ background: 'var(--cor-creme)', border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio-lg)', padding: '20px' }}>
      <p style={{ fontWeight: '600', color: 'var(--cor-principal)', marginBottom: '16px' }}>{titulo}</p>
      <form onSubmit={onSave}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px', marginBottom: '14px' }}>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Nome *</label>
            <input
              type="text"
              value={form.nome}
              onChange={e => setForm(p => ({ ...p, nome: e.target.value }))}
              style={{ ...inputStyle, background: 'var(--cor-branco)' }}
              required
            />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Descrição</label>
            <textarea
              value={form.descricao}
              onChange={e => setForm(p => ({ ...p, descricao: e.target.value }))}
              style={{ ...inputStyle, background: 'var(--cor-branco)', minHeight: '70px', resize: 'vertical' }}
            />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Categoria *</label>
            {novaCategoria ? (
              <div style={{ display: 'flex', gap: '8px' }}>
                <input
                  type="text"
                  value={form.categoria}
                  onChange={e => setForm(p => ({ ...p, categoria: e.target.value }))}
                  style={{ ...inputStyle, background: 'var(--cor-branco)', flex: 1 }}
                  placeholder="Nome da nova categoria"
                  required
                />
                <button type="button" onClick={() => setNovaCategoria(false)} style={{ background: 'none', border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio)', padding: '0 12px', cursor: 'pointer', fontSize: '12px', whiteSpace: 'nowrap' }}>
                  Usar existente
                </button>
              </div>
            ) : (
              <div style={{ display: 'flex', gap: '8px' }}>
                <select
                  value={form.categoria}
                  onChange={e => setForm(p => ({ ...p, categoria: e.target.value }))}
                  style={{ ...inputStyle, background: 'var(--cor-branco)', flex: 1 }}
                >
                  <option value="">Selecionar…</option>
                  {categorias.map(c => <option key={c} value={c}>{c}</option>)}
                </select>
                <button
                  type="button"
                  onClick={() => { setNovaCategoria(true); setForm(p => ({ ...p, categoria: '' })) }}
                  style={{ background: 'none', border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio)', padding: '0 12px', cursor: 'pointer', fontSize: '12px', whiteSpace: 'nowrap' }}
                >
                  + Nova cat.
                </button>
              </div>
            )}
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Duração na agenda (min)</label>
            <input
              type="number" min="5" max="480" step="5"
              value={form.duracao_min}
              onChange={e => setForm(p => ({ ...p, duracao_min: e.target.value }))}
              title="Tempo que o serviço ocupa na agenda e bloqueia o profissional (ex.: cliente + limpeza)."
              style={{ ...inputStyle, background: 'var(--cor-branco)' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Duração real (min)</label>
            <input
              type="number" min="5" max="480" step="5"
              value={form.duracao_real_min}
              onChange={e => setForm(p => ({ ...p, duracao_real_min: e.target.value }))}
              title="Tempo efetivo do serviço, mostrado ao cliente na página de marcações."
              style={{ ...inputStyle, background: 'var(--cor-branco)' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Preço (€)</label>
            <input
              type="number" min="0" step="0.5"
              value={form.preco}
              onChange={e => setForm(p => ({ ...p, preco: e.target.value }))}
              style={{ ...inputStyle, background: 'var(--cor-branco)' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Sinal fixo (€)</label>
            <input
              type="number" min="0" step="0.5"
              value={form.sinal_valor}
              onChange={e => setForm(p => ({ ...p, sinal_valor: e.target.value }))}
              placeholder="usar %"
              title="Opcional. Em branco usa a percentagem base das Configurações."
              style={{ ...inputStyle, background: 'var(--cor-branco)' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>IVA</label>
            <select
              value={form.iva_taxa || 'NOR'}
              onChange={e => setForm(p => ({ ...p, iva_taxa: e.target.value }))}
              title="Taxa de IVA usada na faturação (Vendus)."
              style={{ ...inputStyle, background: 'var(--cor-branco)' }}
            >
              {IVA_TAXAS.map(t => <option key={t.codigo} value={t.codigo}>{t.label}</option>)}
            </select>
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Ordem</label>
            <input
              type="number" min="0"
              value={form.ordem}
              onChange={e => setForm(p => ({ ...p, ordem: e.target.value }))}
              style={{ ...inputStyle, background: 'var(--cor-branco)' }}
            />
          </div>
          <div style={{ gridColumn: '1 / -1', display: 'flex', alignItems: 'center', gap: '10px', paddingTop: '4px' }}>
            <input
              type="checkbox"
              id="visivel_publico"
              checked={form.visivel_publico}
              onChange={e => setForm(p => ({ ...p, visivel_publico: e.target.checked }))}
              style={{ width: '16px', height: '16px', cursor: 'pointer', accentColor: 'var(--cor-principal)' }}
            />
            <label htmlFor="visivel_publico" style={{ fontSize: '13px', fontWeight: '500', cursor: 'pointer', userSelect: 'none' }}>
              Disponível para marcações online (visível ao público)
            </label>
          </div>

          {/* ── Apresentação (opcional): vídeo/imagem + descrição detalhada ──
              Se preenchida, o cliente vê uma página intermédia no booking entre
              o serviço e o profissional. Só editável com a permissão respetiva. */}
          {podeMidia && (
            <div style={{ gridColumn: '1 / -1', borderTop: '1px solid var(--cor-borda)', paddingTop: '14px', marginTop: '4px' }}>
              <p style={{ fontSize: '13px', fontWeight: '600', marginBottom: '4px' }}>Apresentação <span style={{ fontWeight: '400', color: 'var(--cor-texto-suave)' }}>(opcional)</span></p>
              <p style={{ fontSize: '12px', color: 'var(--cor-texto-suave)', marginBottom: '12px', lineHeight: 1.5 }}>
                Vídeo ou imagem mostrados ao cliente antes da escolha do profissional. Vídeos verticais (9:16) e leves resultam melhor no telemóvel; reproduzem em silêncio e em loop.
              </p>

              <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Carregar imagem ou vídeo</label>
              <input
                type="file"
                accept="image/*,video/*"
                onChange={e => { const f = e.target.files?.[0]; if (f) onUpload(f); e.target.value = '' }}
                disabled={aEnviarMidia}
                style={{ fontSize: '13px', marginBottom: '12px', display: 'block' }}
              />
              {aEnviarMidia && <p style={{ fontSize: '12px', color: 'var(--cor-texto-suave)', marginBottom: '12px' }}>A carregar…</p>}

              <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Ou colar um URL (MP4, imagem, etc.)</label>
              <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
                <input
                  type="url"
                  value={form.midia_url}
                  onChange={e => setForm(p => ({ ...p, midia_url: e.target.value }))}
                  placeholder="https://…"
                  style={{ ...inputStyle, background: 'var(--cor-branco)', flex: 1 }}
                />
                <select
                  value={form.midia_tipo || ''}
                  onChange={e => setForm(p => ({ ...p, midia_tipo: e.target.value }))}
                  style={{ ...inputStyle, background: 'var(--cor-branco)', width: '120px' }}
                >
                  <option value="">tipo…</option>
                  <option value="imagem">Imagem</option>
                  <option value="video">Vídeo</option>
                </select>
              </div>

              {form.midia_url && (
                <div style={{ marginBottom: '12px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                    <span style={{ fontSize: '12px', color: 'var(--cor-texto-suave)' }}>Pré-visualização</span>
                    <button type="button" onClick={() => setForm(p => ({ ...p, midia_url: '', midia_tipo: '' }))} style={{ background: 'none', border: 'none', color: '#DC2626', cursor: 'pointer', fontSize: '12px' }}>
                      Remover
                    </button>
                  </div>
                  {form.midia_tipo === 'video' ? (
                    <video src={form.midia_url} muted autoPlay loop playsInline preload="metadata"
                      style={{ width: '160px', aspectRatio: '9 / 16', objectFit: 'cover', borderRadius: 'var(--raio)', background: '#000', display: 'block' }} />
                  ) : (
                    <img src={form.midia_url} alt="Pré-visualização"
                      style={{ width: '160px', aspectRatio: '9 / 16', objectFit: 'cover', borderRadius: 'var(--raio)', display: 'block' }} />
                  )}
                </div>
              )}

              <label style={{ display: 'block', marginBottom: '5px', fontSize: '13px', fontWeight: '500' }}>Descrição detalhada</label>
              <textarea
                value={form.descricao_detalhada}
                onChange={e => setForm(p => ({ ...p, descricao_detalhada: e.target.value }))}
                placeholder="Texto mais completo mostrado na página de apresentação."
                maxLength={1000}
                style={{ ...inputStyle, background: 'var(--cor-branco)', minHeight: '80px', resize: 'vertical' }}
              />
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <button type="submit" className="btn-primario" disabled={guardando} style={{ opacity: guardando ? 0.6 : 1, padding: '9px 22px', fontSize: '14px' }}>
            {guardando ? 'A guardar…' : 'Guardar'}
          </button>
          <button type="button" onClick={onCancel} className="btn-secundario" style={{ padding: '9px 22px', fontSize: '14px' }}>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  )
}

export default function Servicos() {
  const { tenant } = useTenant()
  const { podeFazer } = useAuth()
  const toast = useToast()
  const podeMidia = podeFazer('editar_midia_servico')
  const [lista, setLista] = useState([])
  const [carregando, setCarregando] = useState(true)
  const [editando, setEditando] = useState(null)
  const [form, setForm] = useState(VAZIO)
  const [novaCategoria, setNovaCategoria] = useState(false)
  const [guardando, setGuardando] = useState(false)
  const [aEnviarMidia, setAEnviarMidia] = useState(false)
  const [ordemCat, setOrdemCat] = useState('')
  const [guardandoOrdem, setGuardandoOrdem] = useState(false)

  async function enviarMidia(file) {
    if (file.size > AVISO_TAMANHO_MB * 1024 * 1024) {
      toast.aviso(`Ficheiro com ${(file.size / 1024 / 1024).toFixed(1)} MB — vídeos leves (até ${AVISO_TAMANHO_MB} MB) carregam mais depressa no telemóvel dos clientes.`)
    }
    setAEnviarMidia(true)
    try {
      const { url, tipo } = await uploadMidiaServico(tenant.id, file)
      setForm(p => ({ ...p, midia_url: url, midia_tipo: tipo }))
    } catch (e) {
      toast.erro(e.message)
    } finally {
      setAEnviarMidia(false)
    }
  }

  useEffect(() => {
    if (!tenant) return
    Promise.all([getServicosAdmin(tenant.id), getConfiguracoes(tenant.id)])
      .then(([srv, cfg]) => {
        setLista(srv)
        setOrdemCat(cfg.ordem_categorias || '')
      })
      .catch(e => toast.erro(e.message))
      .finally(() => setCarregando(false))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenant])

  const categorias = ordenarCategorias([...new Set(lista.map(s => s.categoria))], ordemCat)

  // Move uma categoria uma posição para cima/baixo e grava a nova ordem.
  async function moverCategoria(cat, direcao) {
    const idx = categorias.indexOf(cat)
    const alvo = idx + direcao
    if (alvo < 0 || alvo >= categorias.length) return
    const nova = [...categorias]
    ;[nova[idx], nova[alvo]] = [nova[alvo], nova[idx]]
    const anterior = ordemCat
    setOrdemCat(JSON.stringify(nova)) // otimista
    setGuardandoOrdem(true)
    try {
      await salvarOrdemCategorias(tenant.id, nova)
    } catch (e) {
      setOrdemCat(anterior) // reverte
      toast.erro(e.message)
    } finally {
      setGuardandoOrdem(false)
    }
  }

  function iniciarEdicao(s) {
    setEditando(s.id)
    setForm({
      nome: s.nome, descricao: s.descricao || '', categoria: s.categoria,
      preco: String(s.preco),
      sinal_valor: s.sinal_valor != null ? String(s.sinal_valor) : '',
      iva_taxa: s.iva_taxa || 'NOR',
      duracao_min: String(s.duracao_min),
      duracao_real_min: String(s.duracao_real_min ?? s.duracao_min),
      ordem: String(s.ordem), ativo: s.ativo,
      visivel_publico: s.visivel_publico !== false,
      midia_url: s.midia_url || '',
      midia_tipo: s.midia_tipo || '',
      descricao_detalhada: s.descricao_detalhada || '',
    })
    setNovaCategoria(false)
    toast.erro(null)
  }

  function iniciarNovo() { setEditando('novo'); setForm(VAZIO); setNovaCategoria(false); toast.erro(null) }
  function cancelar() { setEditando(null); toast.erro(null) }

  async function guardar(e) {
    e.preventDefault()
    if (!form.nome.trim() || !form.categoria.trim()) {
      toast.erro('Nome e categoria são obrigatórios.')
      return
    }
    setGuardando(true)
    toast.erro(null)
    try {
      const dados = {
        nome: form.nome.trim(),
        descricao: form.descricao.trim() || null,
        categoria: form.categoria.trim(),
        preco: parseFloat(form.preco) || 0,
        sinal_valor: form.sinal_valor !== '' ? (parseFloat(form.sinal_valor) || 0) : null,
        iva_taxa: form.iva_taxa || 'NOR',
        duracao_min: parseInt(form.duracao_min) || 60,
        duracao_real_min: parseInt(form.duracao_real_min) || parseInt(form.duracao_min) || 60,
        ordem: parseInt(form.ordem) || 0,
        ativo: form.ativo,
        visivel_publico: form.visivel_publico,
        midia_url: form.midia_url.trim() || null,
        // O tipo só é guardado quando há média; sem URL não faz sentido.
        midia_tipo: form.midia_url.trim() ? (form.midia_tipo || 'imagem') : null,
        descricao_detalhada: form.descricao_detalhada.trim() || null,
      }
      if (editando === 'novo') {
        const novo = await createServico(tenant.id, dados)
        setLista(prev => [...prev, novo])
      } else {
        await updateServico(tenant.id, editando, dados)
        setLista(prev => prev.map(s => s.id === editando ? { ...s, ...dados } : s))
      }
      setEditando(null)
    } catch (e) {
      toast.erro(e.message)
    } finally {
      setGuardando(false)
    }
  }

  async function toggleAtivo(s) {
    try {
      await updateServico(tenant.id, s.id, { ativo: !s.ativo })
      setLista(prev => prev.map(x => x.id === s.id ? { ...x, ativo: !x.ativo } : x))
    } catch (e) { toast.erro(e.message) }
  }

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '32px 24px 64px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
        <h2 style={{ fontSize: '22px' }}>Serviços</h2>
        <button onClick={iniciarNovo} className="btn-primario" style={{ padding: '9px 20px', fontSize: '14px' }}>
          + Novo
        </button>
      </div>
      <p style={{ color: 'var(--cor-texto-suave)', marginBottom: '28px', fontSize: '14px' }}>
        Catálogo de serviços disponíveis para marcação.
      </p>

      {carregando ? <Loading /> : (
        <>
          {editando === 'novo' && (
            <div style={{ marginBottom: '24px' }}>
              <FormServico
                form={form} setForm={setForm}
                categorias={categorias}
                novaCategoria={novaCategoria} setNovaCategoria={setNovaCategoria}
                onSave={guardar} onCancel={cancelar}
                guardando={guardando} titulo="Novo Serviço"
                podeMidia={podeMidia} onUpload={enviarMidia} aEnviarMidia={aEnviarMidia}
              />
            </div>
          )}

          {categorias.map((cat, idx) => (
            <div key={cat} style={{ marginBottom: '28px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px' }}>
                <p style={{ fontSize: '11px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.1em', color: 'var(--cor-texto-suave)', margin: 0 }}>
                  {cat}
                </p>
                {categorias.length > 1 && (
                  <span style={{ display: 'inline-flex', gap: '2px' }}>
                    <button
                      type="button"
                      onClick={() => moverCategoria(cat, -1)}
                      disabled={idx === 0 || guardandoOrdem}
                      title="Mover categoria para cima"
                      aria-label={`Mover categoria ${cat} para cima`}
                      style={{ background: 'none', border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio)', width: '22px', height: '22px', lineHeight: 1, cursor: idx === 0 ? 'default' : 'pointer', opacity: idx === 0 ? 0.35 : 1, fontSize: '12px', color: 'var(--cor-texto-suave)', padding: 0 }}
                    >
                      ↑
                    </button>
                    <button
                      type="button"
                      onClick={() => moverCategoria(cat, 1)}
                      disabled={idx === categorias.length - 1 || guardandoOrdem}
                      title="Mover categoria para baixo"
                      aria-label={`Mover categoria ${cat} para baixo`}
                      style={{ background: 'none', border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio)', width: '22px', height: '22px', lineHeight: 1, cursor: idx === categorias.length - 1 ? 'default' : 'pointer', opacity: idx === categorias.length - 1 ? 0.35 : 1, fontSize: '12px', color: 'var(--cor-texto-suave)', padding: 0 }}
                    >
                      ↓
                    </button>
                  </span>
                )}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {lista.filter(s => s.categoria === cat).map(s => (
                  <div key={s.id}>
                    <div style={{
                      background: 'var(--cor-branco)', border: '1px solid var(--cor-borda)',
                      borderRadius: 'var(--raio)', padding: '12px 16px',
                      display: 'flex', alignItems: 'center', gap: '12px',
                      opacity: s.ativo ? 1 : 0.5, boxShadow: 'var(--sombra)',
                    }}>
                      <div style={{ flex: 1 }}>
                        <span style={{ fontWeight: '500' }}>{s.nome}</span>
                        <span style={{ fontSize: '12px', color: 'var(--cor-texto-suave)', marginLeft: '10px' }}>{s.duracao_min} min</span>
                        {s.preco > 0 && (
                          <span style={{ fontSize: '12px', color: 'var(--cor-ambar)', marginLeft: '8px' }}>{Number(s.preco).toFixed(2)} €</span>
                        )}
                        {!s.ativo && <span style={{ fontSize: '11px', color: '#9CA3AF', marginLeft: '8px' }}>Inativo</span>}
                        <span
                          title={s.visivel_publico !== false ? 'Disponível para marcações online' : 'Não disponível para marcações online'}
                          style={{
                            display: 'inline-block', width: '8px', height: '8px',
                            borderRadius: '50%', marginLeft: '10px', verticalAlign: 'middle',
                            background: s.visivel_publico !== false ? '#22C55E' : '#D1D5DB',
                          }}
                        />
                        {(s.midia_url || s.descricao_detalhada) && (
                          <span
                            aria-hidden="true"
                            title={s.midia_tipo === 'video' ? 'Tem vídeo de apresentação' : s.midia_url ? 'Tem imagem de apresentação' : 'Tem descrição de apresentação'}
                            style={{ fontSize: '12px', marginLeft: '8px', verticalAlign: 'middle' }}
                          >
                            {s.midia_tipo === 'video' ? '🎬' : s.midia_url ? '🖼️' : '📝'}
                          </span>
                        )}
                      </div>
                      <button
                        onClick={() => toggleAtivo(s)}
                        style={{ background: 'none', border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio)', padding: '4px 10px', cursor: 'pointer', fontSize: '12px', color: 'var(--cor-texto-suave)' }}
                      >
                        {s.ativo ? 'Desativar' : 'Ativar'}
                      </button>
                      <button
                        onClick={() => editando === s.id ? cancelar() : iniciarEdicao(s)}
                        className="btn-secundario"
                        style={{ padding: '4px 10px', fontSize: '12px' }}
                      >
                        {editando === s.id ? 'Cancelar' : 'Editar'}
                      </button>
                    </div>
                    {editando === s.id && (
                      <div style={{ marginTop: '4px' }}>
                        <FormServico
                          form={form} setForm={setForm}
                          categorias={categorias}
                          novaCategoria={novaCategoria} setNovaCategoria={setNovaCategoria}
                          onSave={guardar} onCancel={cancelar}
                          guardando={guardando} titulo="Editar Serviço"
                          podeMidia={podeMidia} onUpload={enviarMidia} aEnviarMidia={aEnviarMidia}
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  )
}
